import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { Base } from 'active-resource';

/**
 * Relationship classes
 */
export class InterviewSlotAttributes {
  dayOfWeek: number = null;
  endTime: string = null;
  id: string = null;
  startTime: string = null;
}

export class InterviewSlotBelongsTo {}
export class InterviewSlotHasOne {}
export class InterviewSlotHasMany {}

/**
 * Utility interfaces
 */
export interface InterviewSlotMethods {}

export interface InterviewSlotInterface
  extends InterviewSlotAttributes,
    InterviewSlotBelongsTo,
    InterviewSlotHasOne,
    InterviewSlotHasMany,
    InterviewSlotType {}

type InterviewSlotType = GConstructor<InterviewSlotInterface>;

export interface InterviewSlotResource
  extends Base<InterviewSlotAttributes>,
    InterviewSlotInterface,
    InterviewSlotMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<InterviewSlotAttributes>({
    queryName: 'interview_slots',
    className: 'InterviewSlot',
    AttributesClass: InterviewSlotAttributes,
    BelongsToClasses: [
      {
        Klass: InterviewSlotBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: InterviewSlotHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: InterviewSlotHasMany,
      },
    ],
  });

export const InterviewSlotResourceClass = <TBase extends InterviewSlotType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements InterviewSlotMethods {};

export class InterviewSlotResource extends ClassExtender<InterviewSlotInterface>(
  BaseClass,
  InterviewSlotResourceClass,
) {}

/**
 * Resource instance
 */
export const InterviewSlot =
  APILibrary.createResource<InterviewSlotResource>(InterviewSlotResource);
